import RackSynth from 'instruments/synth/RackSynth.js';
import ParameterContext from 'effects/ParameterContext.js';
import {MULTI_SYNTH} from 'constants/instrument-types.js';
import InstrumentTrack from './InstrumentTrack.js';

class MultiSynthTrack extends InstrumentTrack {
    constructor(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence, createSynth=false) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence, false);
        if (createSynth) {
            this.setInstrument(
                new RackSynth(
                    sequencerEngine,
                    mixSession,
                    new ParameterContext().forTrack(this),
                    this));
        }
    }

    getInstrumentType() {
        return MULTI_SYNTH;
    }

    createNewInstrument() {
        this.instrument = undefined;
        this.setInstrument(new RackSynth(
                this.sequencerEngine,
                this.mixSession,
                new ParameterContext().forTrack(this),
            this));
    }

    getCopy(constr, sequencerEngine=this.sequencerEngine, ignoreId) {
        return super.getCopy((a,b,c,d,e,f) => new MultiSynthTrack(a,b,c,d,e,f, false), sequencerEngine, ignoreId);
    }


}

export default MultiSynthTrack;
